import Icon from '@material-ui/icons/Description';
import React from 'react';
import { CreateButton } from '../../../buttons';
import { EditDialog, Filter, ResourceList } from '../../../controllers';
import { LinkField, TextField } from '../../../fields';
import { BooleanInput, NestedReferenceInput, TextInput } from '../../../inputs';

export default {
  Icon,
  dialogs: {
    edit: props => (
      <EditDialog
        {...props}
      >
        <TextInput
          label="Prior Coding Experience"
          source="experience"
        />
        <TextInput
          label="Preferred Teaching Style"
          source="styles"
        />
        <TextInput
          label="Interests and Hobbies"
          source="interests"
        />
      </EditDialog>
    ),
    create: props => (
      <CreateButton
        fixedValue={{ 
          organization_id: props.parentResource.id,
        }}
        {...props}
      >
        <NestedReferenceInput
          filter={{ scope: 'child' }}
          source="user_id"
          required
        />
        <TextInput
          label="Prior Coding Experience"
          source="experience"
        />
        <TextInput
          label="Preferred Teaching Style"
          source="styles"
        />
        <TextInput
          label="Interests and Hobbies"
          source="interests"
        />
      </CreateButton>
    ),
  },
  routes: {
    list: props => (
      <ResourceList
        {...props}
      >
        <LinkField
          parentReference="organizations"
          parentSource="organization_id"
          source="user_id"
        />
        <TextField
          label="Prior Coding Experience"
          source="experience"
        />
        <TextField
          label="Preferred Teaching Style"
          source="styles"
        />
        <TextField
          label="Interests and Hobbies"
          source="interests"
        />
      </ResourceList>
    ),
  },
  components: {
    Filter: props => (
      <Filter
        {...props}
      >
        <BooleanInput
          label="Deleted"
          source="deleted"
        />
      </Filter>
    ),
  },
  resources: {
  },
};
